module.exports = __webpack_public_path__ + "assets/img/getBtnButton.b642b52c.png";